import { inject } from '@angular/core';
import { InterpolatableTranslationObject, TranslateService } from '@ngx-translate/core';
import { firstValueFrom } from 'rxjs';

import { ApiConfiguration as RecourseCockpitApiConfiguration } from './api/tur-rc/api-configuration';
import { ApiConfiguration as WarrantyRecourseApiConfiguration } from './api/tur-wr/api-configuration';

export function initializeApiConfigFactory(): void {
  inject(RecourseCockpitApiConfiguration);
  inject(WarrantyRecourseApiConfiguration);
}

export async function appInitializerFactory(): Promise<InterpolatableTranslationObject> {
  const translate = inject(TranslateService);
  const defaultLang = getUsersLocale('de').slice(0, 2); // truncate in case of e.g. 'de-DE'
  translate.setDefaultLang(defaultLang);
  return firstValueFrom(translate.use(defaultLang));
}

export function getUsersLocale(defaultValue: string): string {
  // eslint-disable-next-line no-restricted-globals
  if (typeof window === 'undefined' || window.navigator === undefined) {
    return defaultValue;
  }
  // eslint-disable-next-line no-restricted-globals
  const wn = window.navigator as any;
  let lang = wn.languages ? wn.languages[0] : defaultValue;
  lang = lang || wn.language || wn.browserLanguage || wn.userLanguage;
  return lang;
}
